import startCase from "lodash/startCase";
import upperFirst from "lodash/upperFirst";

import { SEARCH_FIELDS } from "../../search/mappings";
import { INTERESTING_STRINGS_SEARCH_FIELD_MAP } from "./const";

export const convertToSentenceCase = value =>
  upperFirst(startCase(value).toLowerCase());

export const convertNameValueToArray = ({ name, value }) => [name, value];
export const convertNameValueToMappedArray = ({ name, value }, mappingFn) => [
  mappingFn(name),
  value
];

export const messageReplacer = (messages = [], messageMap) =>
  messages.map(m => messageMap.get(m) || m);

export const getInterestingStringSearchKeyword = (string, data) => {
  const category = data?.find(row => row.value === string)?.category;
  return (
    INTERESTING_STRINGS_SEARCH_FIELD_MAP.find(
      item => item.category === category
    )?.keyword || SEARCH_FIELDS.URI_STATIC
  );
};
